<template>
  <el-row>
    <el-col :span="12">
      <basic-attributes :profile-id="profileId" />
      <featured-attributes v-if="isAllowed" :profile-id="profileId" />
      <lifecycle-overview
        v-if="features.customer_intelligence_lifecycle_overview"
        :profile-id="profileId"
      />
    </el-col>

    <el-col :span="12">
      <latest-sessions :profile-id="profileId" v-if="features.mobile" />
      <recent-events :profile-id="profileId" />
      <recent-messages :profile-id="profileId" />
      <latest-viewed-products
        v-if="features.shopbox_enabled"
        :profile-id="profileId"
      />
    </el-col>
  </el-row>
</template>

<script>
import BasicAttributes from '@/modules/profiles/components/BasicAttributes'
import FeaturedAttributes from '@/modules/profiles/components/FeaturedAttributes'
import RecentEvents from '@/modules/profiles/components/RecentEvents'
import LatestSessions from '@/modules/profiles/components/LatestSessions'
import RecentMessages from '@/modules/profiles/components/LatestMessages'
import LifecycleOverview from '@/modules/profiles/components/LifecycleOverview'
import LatestViewedProducts from '@/modules/profiles/components/LatestViewedProducts'

export default {
  name: 'ProfileOverviewPage',

  components: {
    LatestViewedProducts,
    RecentMessages,
    BasicAttributes,
    FeaturedAttributes,
    RecentEvents,
    LatestSessions,
    LifecycleOverview
  },

  props: {
    readonly: {
      type: Boolean,
      required: true
    },

    profileId: {
      type: String,
      required: true
    }
  },

  computed: {
    features() {
      return this.$store.state.app.features
    },
    isAllowed() {
      return (
        this.$can('viewProjectItem') ||
        this.$isRole('consent-admin') ||
        this.$isRole('consent-customer-service-agent')
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileOverviewPage.vue